module.exports = __webpack_public_path__ + "static/media/21.f5761784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/21.jpg
// module id = 282
// module chunks = 0